module.exports = __webpack_public_path__ + "assets/svg/Icons/32/plus-gray-8c71d3.svg";